import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_method_details: {
    title: '{{orderMethod}} in {{waitingTime}} min',
  },
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Consegna',
    [ORDER_METHODS.PICKUP]: 'Ritiro',
    [ORDER_METHODS.ROOM_SERVICE]: 'Room Service',
  },
};
